import React, {Component} from 'react';


class SignaturePolicy extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            text_1 : "I agree and understand that by signing this DBQ Electronic Signature Acknowledgment, that the electronic signature(s) is/are the legal equivalent of my manual/handwritten signature as if I signed the document in writing.  I further agree my signature on this document represents that I have personally examined the patient/veteran and the medical opinions and determinations contained on this form are my own. I further acknowledge that I agree to the terms of use of the",
            text_2 : "where upon this DBQ form resides."
        }
    }
    componentDidMount() {

    }
    render() {
        const {
            onClose
          } = this.props
          let link = "Network Portal & Fast Vet Privacy Policy"
        return (
            <div className="overlay-msg" onClick={e => {onClose(e)}}>
                <div className="overlay-box">
                    <h2><b>DBQ Electronic Signature Acknowledgment</b></h2>
                    <h5 style={{textAlign: 'justify'}}>{this.state.text_1} <b><a href={`${process.env.GENERAL_SITE_URL}/privacy-policy`} target='_blank' style={{color: '#89949b', textDecoration: 'underline'}}>{link}</a> </b> {this.state.text_2}</h5>
                </div>
            </div>
        );
    }
}

export default SignaturePolicy